import { PlusOutlined } from '@ant-design/icons';
import { Button, Form, Tooltip, Upload } from 'antd';
import React, { useContext } from 'react';

import type { NUploadFilesComponent } from '@app/components/UploadFilesComponent/UploadFilesComponent.types';
import { FRONT_WARNING } from '@app/constants';
import { NotificationContext } from '@app/providers';

import type { UploadFile } from 'antd';

export const UploadFilesComponent: React.FC<NUploadFilesComponent.Main> = ({
  formItemName,
  uploadFilesExtensions,
  buttonDataTestId = '',
  maxCount = undefined,
}) => {
  const { showNotification } = useContext(NotificationContext);

  const getAllExtensions = () => {
    return uploadFilesExtensions
      .split(', ')
      .map((ext) => ext.trim().toLowerCase());
  };

  const validateFileExtension = (file: File) => {
    const allowedExtensions = getAllExtensions();
    const fileExtension = `.${file.name.split('.').pop()?.toLowerCase()}`;

    return allowedExtensions.includes(fileExtension);
  };

  const handleBeforeUpload = (file: File) => {
    const isValid = validateFileExtension(file);

    if (!isValid) {
      showNotification(`${file.name} имеет недопустимый формат`, FRONT_WARNING);
    }

    return isValid;
  };

  const filterFileList = ({ fileList }: { fileList: UploadFile[] }) => {
    const allowedExtensions = new Set(getAllExtensions());

    return fileList.filter((file: UploadFile) => {
      const extension = file.name.split('.').pop()?.toLowerCase() ?? '';
      return allowedExtensions.has(`.${extension}`);
    });
  };

  return (
    <Form.Item
      name={formItemName}
      valuePropName="fileList"
      getValueFromEvent={filterFileList}
    >
      <Upload
        maxCount={maxCount}
        multiple
        className="upload-component"
        listType="text"
        accept={uploadFilesExtensions}
        beforeUpload={handleBeforeUpload}
        customRequest={({ onSuccess }) => onSuccess?.(true)}
        itemRender={(originNode) => (
          <div data-testid="file-name">{originNode}</div>
        )}
      >
        <Tooltip
          title={`Максимальное количество загружаемых файлов: ${maxCount}`}
        >
          <Button
            type="primary"
            icon={<PlusOutlined />}
            data-testid={buttonDataTestId}
          >
            Нажмите или перетащите файлы сюда для загрузки
          </Button>
        </Tooltip>
      </Upload>
    </Form.Item>
  );
};
